import { BREAKPOINTS } from '@/constants/breakpoints';
import { useMediaQuery } from '@mui/material';

type DeviceSize = 'mobile' | 'tablet' | 'pc';

type Props = {
	tablet?: number;
	mobile?: number;
};

/**
 * 디바이스 사이즈를 반환하는 훅
 * @param props {tablet?: number , mobile?: number }
 * @returns 디바이스 사이즈
 */
const useDeviceSize = (props?: Props) => {
	const { tablet = BREAKPOINTS.TABLET, mobile = BREAKPOINTS.MOBILE } =
		props || {};

	const deviceSize: DeviceSize = (() => {
		const mb = useMediaQuery(`(max-width: ${mobile}px)`);
		const tb = useMediaQuery(`(max-width: ${tablet}px)`);

		if (mb) {
			return 'mobile';
		}

		if (tb) {
			return 'tablet';
		}

		return 'pc';
	})();

	const headerSize = (() => {
		if (deviceSize === 'mobile') return 50;
		if (deviceSize === 'tablet') return 60;
		return 90;
	})();

	return { deviceSize, headerSize };
};

export default useDeviceSize;
